import i18next from 'i18next';

import { updateConfigUser } from 'common/api/v1/users';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import { SAVE, SAVE_SUCCESS, SAVE_FAILURE } from '../actionTypes';
import { profileConfigurationActions } from '../reducer';

import setCurrentValues from './setCurrentValues';

export default (values) => (dispatch) => {
    const newValues = {};

    if (values.mode) newValues.mode = values.mode.toUpperCase();
    if (values.expanded_sidebar)
        newValues.expanded_sidebar = values.expanded_sidebar;

    dispatch(profileConfigurationActions[SAVE]());

    const message = i18next.t('An error occurred during the process');

    updateConfigUser(newValues)
        .then((response) => {
            if (!response.data || !response.data.settings) {
                dispatch(profileConfigurationActions[SAVE_FAILURE]([message]));
                return;
            }
            dispatch(
                profileConfigurationActions[SAVE_SUCCESS](
                    response.data.settings,
                ),
            );
            dispatch(
                setCurrentValues({
                    auto_timezone: response.data.settings.auto_timezone,
                    language: response.data.settings.language.key,
                    mode: response.data.settings.mode,
                    timezone: response.data.settings.timezone.key,
                }),
            );
        })
        .catch((error) => {
            dispatch(
                profileConfigurationActions[SAVE_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
